<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('subjectGradingRange.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('subjectGradingRange.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click.prevent="() => (show_form = true)"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <!-- table list -->
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'grade_subject.grade.grade_name_foreign'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.grade_subject.subject.subject_name_foreign }}</td>
            <td>{{ record.grading_definition.definition_name_en }}</td>
            <td class="text-center">{{ record.grading_definition.grade }}</td>
            <td class="text-center">
              <i class="fa fa-check text-green" v-if="record.is_percentage"></i>
              <i class="fa fa-times text-red" v-else></i>
            </td>
            <td class="text-center">{{ record.score_start }}</td>
            <td class="text-center">{{ record.score_stop }}</td>
            <td class="text-center">
              <i class="fa fa-check text-green" v-if="record.is_pass"></i>
              <i class="fa fa-times text-red" v-else></i>
            </td>
            <td class="text-center text-primary">
              <a href="#" class="text-primary" @click.prevent="edit(record)">
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form action -->
      <a-modal
        v-if="show_form"
        v-model="show_form"
        :title="$t('subjectGradingRange.pageTitle')"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="80%"
      >
        <form-create-component
          @close="() => (show_form = false)"
          @fetch="fetchData"
        />
      </a-modal>
      <a-modal
        v-if="show_form_edit"
        v-model="show_form_edit"
        :title="resource.grade_subject.subject.subject_name_foreign"
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="80%"
      >
        <form-edit-component
          @close="() => (show_form_edit = false)"
          @fetch="fetchData"
          :resource="resource"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import FormCreateComponent from './form-create'
import FormEditComponent from './form-edit.vue'

export default {
  name: 'subjectGradingRange',
  components: {
    FormCreateComponent,
    FormEditComponent
  },
  data() {
    return {
      loading: false,
      show_form: false,
      show_form_edit: false,
      resource: null
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('subjectGradingRange', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.subjectGradingRange.search
      },
      set(newValue) {
        this.$store.commit('subjectGradingRange/SET_SEARCH', newValue)
        this.$store.commit('subjectGradingRange/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('subjectGradingRange.subjectName') },
        { name: this.$t('subjectGradingRange.definitionName') },
        {
          name: this.$t('subjectGradingRange.grading'),
          style: 'text-align:center'
        },
        {
          name: this.$t('subjectGradingRange.percentage'),
          style: 'text-align:center'
        },
        {
          name: this.$t('subjectGradingRange.minScore'),
          style: 'text-align:center'
        },
        {
          name: this.$t('subjectGradingRange.maxScore'),
          style: 'text-align:center'
        },
        {
          name: this.$t('subjectGradingRange.pass'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    ...mapActions('subjectGradingRange', ['update']),
    onUpdate() {
      this.waiting = true
      this.update({
        id: this.model.grade_subject_grading_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.show_form = false
          this.fetchData()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('subjectGradingRange/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.show_form_edit = true
      this.resource = record
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  }
}
</script>
